import { Ticker } from '@/app/components/motionplus/Ticker';
import React from 'react';

// Type for valid content types
export type ContentType = 'image' | 'lottie' | 'marquee';

export type PillMarqueeItem = {
  icon?: React.ReactNode;
  text: string;
};

type PillProps = {
  item: PillMarqueeItem;
  pillStyles: React.CSSProperties;
};

const Pill = ({ item, pillStyles }: PillProps) => {
  return (
    <div className="flex items-center rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap" style={pillStyles}>
      {item.icon && <span className="mr-2">{item.icon}</span>}
      {item.text}
    </div>
  );
};

interface PillMarqueeProps {
  items: PillMarqueeItem[];
  pillStyles: React.CSSProperties;
  className?: string;
  'data-content-type'?: ContentType;
}

export const PillMarquee = ({ items, pillStyles, className = '', ...props }: PillMarqueeProps) => {
  // Create pill components for the ticker
  const pillItems = items.map((item, index) => (
    <Pill key={`${item.text}-${index}`} item={item} pillStyles={pillStyles} />
  ));

  // Split into multiple rows for visual variety
  const chunkSize = Math.ceil(items.length / 3);
  const rows = [
    pillItems.slice(0, chunkSize),
    pillItems.slice(chunkSize, chunkSize * 2),
    pillItems.slice(chunkSize * 2),
  ];

  return (
    <div className={className} {...props}>
      {rows.map((rowItems, index) => (
        <Ticker
          key={index}
          items={rowItems}
          velocity={40 + index * 5} // vary speed by 5px
          gap={8}
          axis="x"
          align="center"
          className="min-h-[48px]"
          overflow={true}
        />
      ))}
    </div>
  );
};
